export const CART = {
  ITEM_ADDED: "Cart item is added successfully!",
  ITEM_UPDATED: "Cart item is updated successfully!",
};

export const WISHLIST = {
  LIKE: "Restaurant is added to Favorites!",
  DISLIKE: "Restaurant is removed from Favorites!",
};

export const COUPONS = {
  ACCEPT: "Coupon code is applied successfully!",
  REJECT: "Coupon code is rejected!",
};

export const PAYMENT = {
  FAILED: "Payment is failed!",
};

export const QUANTITY_UPDATED = "Quantity is updated successfully!";

export const PRICE_SYMBOL = "$";
